import { createReducer } from 'lib/utilities.js';

const initialState = {
  adwordsAdGroups: [],
  adwordsAdGroupsLoadState: true,
  adwordsSelectedCampaignLoadState: true,
  adwordsCampaignsLoading: true,
  conversionsDailyStats: [],
  adwordsCampaignsComparisonData: [],
  selectedAdwordsCampaignId: undefined,
  clicksDailyStats: [],
  impressionsDailyStats: [],
  adwordsCampaigns: [],
  ctrDailyStats: [],
  selectedGraphType: 'Impressions',
  costPerConversionDailyStats: [],
  adwordsDailyStatsLineChartLoadState: true,
  paidAdsMCCAccount: null,
};

export default createReducer(initialState, {
  FETCHING_ADWORDS_MCC_ACCOUNTS_SUCCESS: (state, payload) => {
    return {
      ...state,
      ...(payload.length ? { paidAdsMCCAccount: payload[0].id } : {}),
    };
  },
  setGraphTypeAdwordsCampaigns: (state, payload) => {
    return {
      ...state,
      selectedGraphType: payload,
      adwordsDailyStatsLineChartLoadState: true,
    };
  },
  setAdwordsSelectedCampaignLoadState: (state, payload) => {
    return {
      ...state,
      adwordsSelectedCampaignLoadState: payload,
    };
  },
  resetAdwordsCompareData: (state) => {
    return {
      ...state,
      ctrDailySecondDateStats: [],
      impressionsDailySecondDateStats: [],
      clicksDailySecondDateStats: [],
      conversionsDailySecondDateStats: [],
      costPerConversionDailySecondDateStats: [],
      adwordsCampaignsComparisonData: [],
    };
  },
  FETCHING_ADWORDS_ADGROUPS_SUCCESS: (state, payload) => {
    return {
      ...state,
      adwordsAdGroups: payload,
      adwordsAdGroupsLoadState: false,
    };
  },
  fetchingAdwordsCampaignsComparisonData_SUCCESS: (state, payload) => {
    return {
      ...state,
      adwordsCampaignsComparisonData: payload,
      adwordsSelectedCampaignLoadState: false,
    };
  },

  // Daily campaign stats
  fetchingAdwordsCampaignDailyCostPerConversion_SUCCESS: (state, payload) => {
    return {
      ...state,
      costPerConversionDailyStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailyConversions_SUCCESS: (state, payload) => {
    return {
      ...state,
      conversionsDailyStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailyClicks_SUCCESS: (state, payload) => {
    return {
      ...state,
      clicksDailyStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailyImpressions_SUCCESS: (state, payload) => {
    return {
      ...state,
      impressionsDailyStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailyCtr_SUCCESS: (state, payload) => {
    return {
      ...state,
      ctrDailyStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  // Daily campaign comparisonData
  fetchingAdwordsCampaignDailySecondDateCostPerConversion_SUCCESS: (state, payload) => {
    return {
      ...state,
      costPerConversionDailySecondDateStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailySecondDateConversions_SUCCESS: (state, payload) => {
    return {
      ...state,
      conversionsDailySecondDateStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailySecondDateClicks_SUCCESS: (state, payload) => {
    return {
      ...state,
      clicksDailySecondDateStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailySecondDateImpressions_SUCCESS: (state, payload) => {
    return {
      ...state,
      impressionsDailySecondDateStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  fetchingAdwordsCampaignDailySecondDateCtr_SUCCESS: (state, payload) => {
    return {
      ...state,
      ctrDailySecondDateStats: payload,
      adwordsDailyStatsLineChartLoadState: false,
    };
  },
  FETCHING_ADWORDS_CAMPAIGNS_SUCCESS: (state, payload) => {
    return {
      ...state,
      adwordsCampaigns: payload,
      adwordsCampaignsLoading: false,
    };
  },
  uiResetPaidAdsData: (state) => {
    return {
      ...state,
      paidAdsDateCompareDateValue: null,
    };
  },
  setAdwordsCampaignId: (state, payload) => {
    return {
      ...state,
      selectedAdwordsCampaignId: payload.data,
    };
  },
  setAdwordsMCCAccount: (state, payload) => {
    return {
      ...state,
      paidAdsMCCAccount: payload,
      selectedAdwordsCampaignId: null,
    };
  },
});
